import React, { useState, useEffect } from 'react';
import { Chip } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import { ClientDataApi, DataApi } from 'configuration-schemas/confdefnView';
import { getUrl } from 'src/pages/AssortmentBuild/StyleEdit/StyleEdit.utils';
import { getListDataValidValues, getValidValues } from 'src/pages/AssortmentBuild/StyleEdit/StyleEditSection/StyleEditSection.client';
import ServiceContainer from 'src/ServiceContainer';
import { errorToLoggingPayload } from 'src/services/loggingService';
import { noop } from 'lodash';

// TODO replace these with typestyle classes and put them somewhere else
const useStyles = makeStyles({
  chip: {
    borderRadius: '20px',
    padding: '6px 12px',
    fontSize: '14px',
    fontWeight: 400,
    cursor: 'pointer',
    transition: 'all 0.2s ease',
    '&:hover': {
      opacity: 0.8,
    },
  },
  selected: {
    backgroundColor: '#000000 !important',
    color: '#ffffff !important',
    '&:hover': {
      backgroundColor: '#000000 !important',
    },
  },
  unselected: {
    backgroundColor: '#f5f5f5 !important',
    color: '#999999 !important',
    border: 'none',
    '&:hover': {
      backgroundColor: '#f5f5f5 !important',
    },
  },
});

interface InputChipProps {
  configApi: DataApi;
  rendererParams?: any;
  inputParams?: any;
  onSelectionChanged?: (selection: string[]) => void;
  onDataLoaded?: () => void;
}

export const InputChip = ({ configApi, onSelectionChanged, onDataLoaded = noop }: InputChipProps) => {
  const classes = useStyles();
  const [options, setOptions] = useState<string[]>([]);
  const [selectedOptions, setSelectedOptions] = useState<string[]>([]);

  useEffect(() => {
    if (configApi) {
      const prom = (configApi?.isListData) ? getListDataValidValues(configApi) : getValidValues(getUrl(configApi), false, false, false);
      prom
        .then((validValues) => {
          const opts = validValues.map((i: { label: string }) => i.label);
          setOptions(opts);
        })
        .then(() => {
          onDataLoaded();
        })
        .catch((err) => ServiceContainer.loggingService.error('An error occurred fetching the selection options', errorToLoggingPayload(err)));
    }
  }, [configApi]);

  const handleChipClick = (option: string) => {
    // TODO add option for multi select?
    let newSelections = [...selectedOptions];

    if (newSelections.indexOf(option) === -1) {
      newSelections.push(option);
    } else {
      newSelections = newSelections.filter((selection) => selection !== option);
    }

    setSelectedOptions(newSelections);

    if (onSelectionChanged) {
      onSelectionChanged(newSelections);
    }
  };

  // TODO replace style tags with classes or remove them if unneeded
  return (
    <div style={{ display: 'flex', flexWrap: 'wrap', gap: '8px', padding: '8px' }}>
      {options.map((option) => {
        const isSelected = selectedOptions.indexOf(option) !== -1;
        return (
          <Chip
            key={option}
            label={option}
            onClick={() => handleChipClick(option)}
            className={`${classes.chip} ${isSelected ? classes.selected : classes.unselected}`}
          />
        );
      })}
    </div>
  );
};
